import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip'

const editIconTooltip = (props) => (
    <Tooltip {...props}>Edit</Tooltip>
);

const updateIconTooltip = (props) => (
    <Tooltip {...props}>Update</Tooltip>
);

const deleteIconTooltip = (props) => (
    <Tooltip {...props}>Delete</Tooltip>
);

const previewIconTooltip = (props) => (
    <Tooltip {...props}>Preview</Tooltip>
);

const saveIconTooltip = (props) => (
    <Tooltip {...props}>Save</Tooltip>
);

const resetIconTooltip = (props) => (
    <Tooltip {...props}>Reset</Tooltip>
);

const uploadIconTooltip = (props) => (
    <Tooltip {...props}>Upload</Tooltip>
);

const submitIconTooltip = (props) => (
    <Tooltip {...props}>Submit</Tooltip>
);

const nextIconTooltip = (props) => (
    <Tooltip {...props}>Next</Tooltip>
);

const previousIconTooltip = (props) => (
    <Tooltip {...props}>Previous</Tooltip>
);

const exampleIconTooltip = (props) => (
    <Tooltip {...props}>Example</Tooltip>
);


export { editIconTooltip, updateIconTooltip, deleteIconTooltip, previewIconTooltip, saveIconTooltip, resetIconTooltip, submitIconTooltip, uploadIconTooltip, nextIconTooltip, previousIconTooltip ,exampleIconTooltip};